import { FC } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { FormData } from '../constants';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	errors: FieldErrors<FormData>;
	trigger: UseFormTrigger<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const DailyInput: FC<Props> = ({ formWatch, control, errors, trigger, setValue }) => {
	return (
		<>
			{formWatch.recurrenceType === 'DAILY' ? (
				<Controller
					name="includeWeekends"
					control={control}
					render={() => (
						<>
							<FormControlLabel
								control={
									<Checkbox
										id="includeWeekends"
										name="includeWeekends"
										checked={formWatch.includeWeekends}
										onChange={(evt) => {
											setValue('includeWeekends', evt.target.checked, { shouldValidate: true });
										}}
									/>
								}
								label="Include Weekends"
							/>
						</>
					)}
				/>
			) : (
				''
			)}
		</>
	);
};

export default DailyInput;
